import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import SingleView from './SingleFormView';
import { useSelector } from 'react-redux';
import { getAllSpices, getApmcOneTimeFormOneApplicationDetails, getApmcPurposes, newOneTimeDocUpload } from '../../../auth/services/privateapicalling';
import { fruitOptions,vegetableOptions } from '../../../../core/data/json/role';
import { Option } from '../../license-registration-form/CommonSelect';
import { getAllAPMC } from '../../../auth/services/apiCalling';
import { toast, ToastContainer } from 'react-toastify';
import ResubmissionForm from './resubmissionOneTimeForm';
import { fieldsOptions,docOptions } from '../../../applicationOneTime/previewOneTimeApplication';



const APMCFormView = () => {
const location = useLocation();
  const language = useSelector((state: any) => state.auth.language);
const commentOption=[...fieldsOptions,...docOptions];
   const [talukaOptions , setTalukaOptions] = useState<Option[]>([]);
    const [spicesOptions, setSpicesOptions] = useState([]);
  
     const [loading , setLoading] = useState(false)
    const [rawPurposes, setRawPurposes] = useState([])
      const userDetail = useSelector((state: any) => state.auth.userDetails);
 const [reviews , setReviews] = useState<any[]>([])
   const [rejectedFieldName, setRejectedFieldName] = useState({});
  const [rejectedDocName, setRejectedDocName] = useState([]);
const [applicationId, setApplicationID] = useState(location?.state?.applicationId);
 const [data, setData] = useState<any>(
   {}
   );

    
   const token = useSelector((state: any) => state.auth.token);
     const [selectedDocId, setSelectedDocId] = React.useState<string | null>(null);
  // Helper function to get value from nested array structure
  const getFieldValue = (arr, fieldName) => {
    if (!arr || !Array.isArray(arr)) return null;
    const item = arr.find(item => item.fieldName === fieldName);
    return item ? item.value : null;
  };

const fetchApplicationDetails = async (appId: any) => {
    try {
      //.log("fff");
      //.log("apppidddd", appId);
      const data = await getApmcOneTimeFormOneApplicationDetails(appId, token);
      setData(data.data);
      //.log("datdatadataa", data);
      if(data?.data?.appStatusLevel==="pendingAtApmcSecretaryResubmission"){
       const trans = data?.data?.ApmcDetailTransaction.filter(data=>data.appStatusLevel == "pendingAtApmcSecretaryResubmission" )
    
     const latestComment = trans.reduce((acc , curr)=>{
        return curr.createdAt > acc.createdAt ? curr: acc
    }).comment;
  
   const arrOfComment = [...latestComment.matchAll(/([\w]+):\s*(.*?)(?=,\s*\w+:|$)/g)].map(match => ({
  key: match[1].trim(),
  value: match[2].trim()
}));
  
   
    setReviews(arrOfComment)}
     

      
      
    
    } catch (err) {
        
    } finally {

    }
  };
  // Helper to render document link
  const renderDocument = (docId) => {
    if (!docId) return <span className="text-muted">Not uploaded</span>;
   return (
    <Link
    to="#"
    data-bs-toggle="modal"
    data-inert={true}
    data-bs-target="#apmc_modal"
    className="btn btn-outline-info align-items-center w-75"
    onClick={() => {
      setSelectedDocId(docId);
    
    }}
  >
    <i className="ti ti-eye"></i> View Document
  </Link>
  );
  };
const fetchspices=async()=>{
  try{
const response=await getAllSpices(token);
      
      const formatted = response.data.map(item => ({
        value: item.id,
        label: item.Spices,
      }));
   
      setSpicesOptions(formatted);
  }catch(err){

  }
}
 

const handleSelectScheme = async (scheme) => {
  try {
    const resp = await getApmcPurposes(scheme);
    const raw = resp?.purpose || []; 
    
    // Filter to only include ids up to 38, then transform
    const transformedPurposes = raw
      .filter(purpose => purpose.id <= 38)
      .map(purpose => ({
        value: purpose.id,
        label: purpose.subName
      }));
    
    setRawPurposes(transformedPurposes);
  } catch (error) {
   
  }
};
  const fetchTaluka=async()=>{
    try{
 const response = await getAllAPMC(token , userDetail?.Department?.district_id,'' );
 if(response?.success){
 const talukas = response.data.map((t) => ({
          label: t.Taluka,
          value: t.Taluka,
        }));
        setTalukaOptions(talukas)
 }
    }catch{
  return [];
    }
  }
useEffect(() => {
    //.log("pppppppppp");

    //.log("param id", applicationId);

    fetchApplicationDetails(applicationId);
    // fetchTraderApplicationButton();
  }, []);
  useEffect(() => {
    if(data?.appStatusLevel==="pendingAtApmcSecretaryResubmission"){
              setRejectedFieldName(data?.rejectedFieldName || {});
      setRejectedDocName(data?.rejectedDocName || []);
     fetchTaluka();
  handleSelectScheme("all")
  fetchspices()
    }
  }, [data]);
 const handleResubmitSuccess = () => {
    // Refresh the application details after successful resubmission
    fetchApplicationDetails(applicationId);
    setReviews([]);
  
    // toast.success("Application resubmitted successfully!");
  };

  return (
    <>
    <div className="page-wrapper p-3 mt-5">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">{language.track_app} </h3>
              </div>
            </div>
          </div>
   

      {/* Review comments section */}
      {reviews.length > 0 && (
        <div className="card mb-4">
          <div className="card-header bg-danger text-white">
            <h5 className="mb-0">Review By Department</h5>
          </div>
          <div className="card-body">
            {reviews.map((item, index) => (
              <div key={index} className="mb-2">
                <strong> {(() => {
                                                    const role = commentOption.find(
                                                      (option) => option.value === item.key
                                                    );
                                                  
                                                    return role?.label || item.key;
                                                  })()}:</strong> {item.value}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Resubmission Form */}
      {data?.appStatusLevel === "pendingAtApmcSecretaryResubmission" && (
        <ResubmissionForm
          applicationId={data}
          rejectedFieldName={rejectedFieldName}
          rejectedDocName={rejectedDocName}
          talukaOptions={talukaOptions}
          spicesOptions={spicesOptions}
          rawPurposes={rawPurposes}
          onSubmitSuccess={handleResubmitSuccess}
        />
      )}
      <div className="d-flex flex-column text-nightblue align-items-center justify-content-center">
        <div
          id="table"
          className="w-100 overflow-hidden border bg-white border-secondary rounded mb-5"
        >
          <div
            id="head"
            className="d-flex w-100 rounded-top border-bottom border-secondary"
            style={{ backgroundColor: "#CCE3FF" }}
          >
            <h4 className="col-1 d-flex justify-content-center align-items-center">
              S.No.
            </h4>
            <h4 className="col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary">
              પ્રશ્ન(Field)
            </h4>
            <h4 className="col-5 p-2 justify-content-center d-flex align-items-center">
              જવાબ(Response)
            </h4>
          </div>

          {/* Field 01 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              01.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર સમિતિની નોંધણી(Registration of the Market Committee)
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="d-flex gap-2 w-75">
                <div className="d-flex flex-column w-50">
                  {renderDocument(data?.registrationDoc)}
                </div>
                 <div className="d-flex flex-column w-50">
                  <small className="text-muted">Date</small>
                  <strong>{data?.registrationDate}</strong>
          
                </div>
              </div>
            </div>
          </div>

          {/* Field 02 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              02.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                તમારા જિલ્લો અને તાલુકા પસંદ કરો(Select your District and
                talukas)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75 bg-light p-2 rounded border">
                <strong>District: </strong>{data?.districtName}
              </div>

              <div className="w-75 bg-light p-2 rounded border">
                <strong>Talukas: </strong>{data?.talukasName?.join(", ")}
              </div>
            </div>
          </div>

          {/* Field 03 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              03.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર વિસ્તારમાં આવતા ગામોની સંખ્યા.(Number of villages falling
                within market area)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                <strong >{data?.noOfVillagesmarket}</strong>
              </div>
            </div>
          </div>

          {/* Field 04 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              04.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">ઇ-મેલ આઇડી(Email ID)*</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                <strong>{data?.emailID}</strong>
              </div>
            </div>
          </div>

          {/* Field 05 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              05.
            </h4>

            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                ચેરમેન/સેક્રેટરીનું નામ અને મોબાઇલ નંબર (Name & Mobile Number of
                Chairman/Secretary)
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
              {/* Chairman row */}
              <div className="d-flex gap-2 w-75">
                <div className="d-flex flex-column w-50">
                  <small className="text-muted">Chairman Name</small>
                  <strong>{data?.chairmanName}</strong>
                </div>

                <div className="d-flex flex-column w-50">
                  <small className="text-muted">Mobile Number</small>
                  <strong>{data?.chairmanMobileNo}</strong>
                </div>
              </div>

              {/* Secretary row */}
              <div className="d-flex gap-2 w-75">
                <div className="d-flex flex-column w-50">
                  <small className="text-muted">Secretary Name</small>
                  <strong>{data?.secreataryName}</strong>
                </div>

                <div className="d-flex flex-column w-50">
                  <small className="text-muted">Mobile Number</small>
                  <strong>{data?.secreataryMobileNo}</strong>
                </div>
              </div>
            </div>
          </div>

          {/* Field 06 - Multiple sub-fields */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              06.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં ખેડૂતોની સંખ્યા(Number of
                farmers covered under the jurisdiction of the Market Committee)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                <strong >{data?.noOfFarmerApmc}</strong>
              </div>
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં વેપારીઓની સંખ્યા(Number of
                traders coming under the purview of the market committee)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                <strong>{data?.noOfTraderApmc}</strong>
              </div>
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં કમિશન એજન્ટોની સંખ્યા(Number
                of commission agents coming under the purview of the Market
                Committee)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                <strong >{data?.noOfAgentsApmc}</strong>
              </div>
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં સહકારી ખરીદ વેચાણ મંડળીઓની
                સંખ્યા.(Number of cooperative purchase and sale societies
                falling under the purview of the market committee.)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                <strong>{data?.noOfSocietesApmc}</strong>
              </div>
            </div>
          </div>

          {/* Field 07 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              07.
            </h4>

            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                નવા ચૂંટણી બાદ APMCની પ્રથમ સામાન્ય બેઠકની તારીખ (Date of the
                First General meeting of APMC after fresh election)*
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
              <div className="d-flex gap-2 w-75">
                <div className="d-flex flex-column w-50">
                  <small className="text-muted">Date</small>
                  <strong>{data?.lastElectionDate}</strong>
                </div>

                <div className="d-flex flex-column w-50">
                  {renderDocument(data?.electionResultDoc)}
                </div>
              </div>
            </div>
          </div>

          {/* Field 08 - License Details */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              08.
            </h4>
            <div className="col-6 border-start border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                લાઇસન્સ ધારક વેપારીઓની વિગતો (કુલ)(Details of license-holding
                traders (Total)):
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center"></div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">યુનિફાઇડ લાયસન્સ(Unified License)</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                <strong >{data?.noOfunifiedLicense}</strong>
              </div>
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                જનરલ કમિશન એજન્ટ્સ(General commission agents)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                <strong >{data?.noOfgca}</strong>
              </div>
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">અન્ય લાયસન્સ(Other License)</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                <strong >{data?.noOfotherLicense}</strong>
              </div>
            </div>
          </div>

          {/* Field 09 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              09.
            </h4>

            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                છેલ્લી ઓડિટની તારીખ દાખલ કરો અને ઓડિટ રિપોર્ટ અપલોડ કરો. (Enter
                the last audit date and upload the audit report)*
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
              <div className="d-flex gap-2 w-75">
                <div className="d-flex flex-column w-50">
                  <small className="text-muted">Last Audit Date</small>
                  <strong>{data?.lastAuditDate}</strong>
                </div>

                <div className="d-flex flex-column w-50">
                  {renderDocument(data?.lastAuditDoc)}
                </div>
              </div>
            </div>
          </div>

          {/* Field 10 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              10.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">APMC ના પેટા કાયદા(bye laws of APMC)*</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                {renderDocument(data?.byeLawsDoc)}
              </div>
            </div>
          </div>

          {/* Field 11 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              11.
            </h4>

            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                મુખ્યયાર્ડ-સરનામા સાથે (Main yard with address)*
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
              {data?.mainYardDetails && data?.mainYardDetails.map((yard, index) => (
                <div key={index} className="w-75 border rounded p-3 bg-light">
                  <div className="d-flex flex-column gap-2">
                    <div>
                      <small className="text-muted">Name</small>
                      <div><strong>{yard?.name}</strong></div>
                    </div>

                    <div className="d-flex gap-2">
                      <div className="w-50">
                        <small className="text-muted">Date</small>
                        <div><strong>{yard?.date}</strong></div>
                      </div>

                      <div className="w-50">
                        <small className="text-muted">Address</small>
                        <div><strong>{yard?.address}</strong></div>
                      </div>
                    </div>

                    <div>
                      {renderDocument(yard?.doc)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Field 12 - Multiple Sub Yards */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              12.
            </h4>

            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                સબયાર્ડ-સરનામા સાથે (Sub yards with address)*
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
              {data?.subYardDetails && data?.subYardDetails.map((subYard, index) => (
                <div key={index} className="w-100 border rounded p-3 bg-light">
                  <div className="mb-2">
                    <strong>Sub Yard {index + 1}</strong>
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <div>
                      <small className="text-muted">Name</small>
                      <div><strong>{subYard?.name}</strong></div>
                    </div>

                    <div className="d-flex gap-2">
                      <div className="w-50">
                        <small className="text-muted">Date</small>
                        <div><strong>{subYard?.date}</strong></div>
                      </div>

                      <div className="w-50">
                        <small className="text-muted">Address</small>
                        <div><strong>{subYard?.address}</strong></div>
                      </div>
                    </div>

                    <div>
                      {renderDocument(subYard?.doc)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Field 13 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              13.
            </h4>
            <div className="col-6 border-start border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">વિવિધ વિગતો (Miscellaneous details)</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center"></div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                શાકભાજી અને ફળોની વેપાર પ્રવૃત્તિ થાય છે કે નહીં?(Trading in
                Vegetables & Fruits)
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="w-75">
                <strong>{getFieldValue(data?.isTradingFruitVeg, "isfruitvegetable") === "yes" ? "Yes" : "No"}</strong>
              </div>
            </div>
          </div>

          {getFieldValue(data?.isTradingFruitVeg, "isfruitvegetable") === "yes" && (
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>

              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center p-2"></div>

              <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                {/* Vegetables */}
                <div className="w-100 d-flex flex-column align-items-center gap-2">
                  <p className="m-0 fw-bold">શાકભાજી (Vegetables)</p>
                  <div className="w-75 bg-light p-2 rounded border">
                    {Array.isArray(getFieldValue(data?.isTradingFruitVeg, "vegetables")) ? getFieldValue(data?.isTradingFruitVeg, "vegetables").join(", ") : getFieldValue(data?.isTradingFruitVeg, "vegetables")}
                  </div>
                </div>

                {/* Fruits */}
                <div className="w-100 d-flex flex-column align-items-center gap-2">
                  <p className="m-0 fw-bold">ફળો (Fruits)</p>
                  <div className="w-75 bg-light p-2 rounded border">
                    {Array.isArray(getFieldValue(data?.isTradingFruitVeg, "fruits")) ? getFieldValue(data?.isTradingFruitVeg, "fruits").join(", ") : getFieldValue(data?.isTradingFruitVeg, "fruits")}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                એપીએમસીમાં અન્ય કયા માલ-વસ્તુઓનું વેપાર થાય છે?(Other commodities
                traded in APMC)*
                </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                    <strong>{data?.otherCommoditiesInApmc?.join(", ")}</strong>
                </div>
            </div>
            </div>
            <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
                14.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                મંજૂર સ્ટાફની વિગતો અને સંબંધિત દસ્તાવેજો(Details of approved staff
                and related documents)*
                </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="d-flex gap-2 w-75">
                <div className="d-flex flex-column w-50">
                    {renderDocument(data?.approvedStaffDoc)}
                </div>
                <div className="d-flex flex-column w-50">
                    <small className="text-muted">Total Approved Staff</small>
                    <strong>{data?.totalApprovlStaff}</strong>
                </div>
                </div>
                <div className="w-75 mt-2">
                <small className="text-muted">Total Recruited Staff</small>
                <div><strong>{data?.totalRecruitStaff}</strong></div>
                </div>
            </div>
            </div>
            <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
                15.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                APMC કૅન્ટીન સુવિધા(Canteen facility in APMC)*
                </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                <strong>{getFieldValue(data?.apmcCanteenFacility, "hasCanteen") === "yes" ? `Yes, Seating Capacity: ${getFieldValue(data?.apmcCanteenFacility, "seatingCapacity")}` : "No"}</strong>
                </div>
            </div>
            </div>
            <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
                16.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                APMC ગેસ્ટ હાઉસ સુવિધા(Guest house facility in APMC)*
                </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                <strong>{getFieldValue(data?.apmcGuestHouse, "hasGuestRoom") === "yes" ? `Yes, Bed Capacity: ${getFieldValue(data?.apmcGuestHouse, "bedCapacity")}` : "No"}</strong>
                </div>
            </div>
            </div>
            <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
                17.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                ઇન્ફ્રાસ્ટ્રક્ચર સુવિધાઓની વિગતો (Details of infrastructure facilities)*
                </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                <strong>{data?.detailsInfrastructureFacilities?.map(facility => facility.value).join(", ")}</strong>
                </div>
            </div>
            </div>
            <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
                18.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                APMC ની ખાનગી જમીન અને ભાડે લેવામાં આવેલી જમીનની વિગતો (Details of
                private and leased land of APMC)*
                </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                <strong>
                    {getFieldValue(data?.apmcPrivateLand, "hasPrivateLand") === "yes"
                    ? `Private Land - Yes, Hectare: ${getFieldValue(data?.apmcPrivateLand, "hectare")}, Area: ${getFieldValue(data?.apmcPrivateLand, "area")}, Sq Meter: ${getFieldValue(data?.apmcPrivateLand, "sqmeter")}`
                    : "Private Land - No"}
                </strong>
                </div>
                <div className="w-75 bg-light p-2 rounded border">
                <strong>
                    {getFieldValue(data?.apmcLeaseLand, "hasPrivateLand") === "yes"
                    ? `Leased Land - Yes, Hectare: ${getFieldValue(data?.apmcLeaseLand, "hectare")}, Area: ${getFieldValue(data?.apmcLeaseLand, "area")}, Sq Meter: ${getFieldValue(data?.apmcLeaseLand, "sqmeter")}, Lease Period: ${getFieldValue(data?.apmcLeaseLand, "leasePeriod")} years`
                    : "Leased Land - No"}
                </strong>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
     <SingleView docId={selectedDocId} />
     <ToastContainer position='top-right' autoClose={3000} />
     </>
    );
};
export default APMCFormView;